import "./01_component.css"

import { useState, useRef, useEffect } from "react";

import Graphic3 from "../../../assets/Images/Elements/ArrowWhite.svg"

import Arrow from "../../../assets/Images/Elements/Arrow_O1.svg"

import Image11 from "../../../assets/Images/Home/1.jpg"
import Image2 from "../../../assets/Images/Home/2.jpg"
import Image3 from "../../../assets/Images/Home/3.jpg"
import Image4 from "../../../assets/Images/Home/4.jpg"
import Image5 from "../../../assets/Images/Home/5.jpg"
import Image6 from "../../../assets/Images/Home/6.jpg"

export default function Index() {
    const [stepT, setStepT] = useState(1);
    const TOTAL_SLIDES = 6;

    const selectorRef = useRef(null);
    const itemRefs = useRef([]);

    const autoSlideRef = useRef(null);
    const pauseTimeoutRef = useRef(null);

    const scrollToItem = (index) => {
        const item = itemRefs.current[index];
        const container = selectorRef.current;

        if (!item || !container) return;

        const itemLeft = item.offsetLeft;
        const containerWidth = container.offsetWidth;
        const itemWidth = item.offsetWidth;

        container.scrollTo({
            left: itemLeft - containerWidth / 2 + itemWidth / 2,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        startAutoSlide();
        return stopAutoSlide;
    }, []);

    const startAutoSlide = () => {
        stopAutoSlide();
        autoSlideRef.current = setInterval(() => {
            setStepT(prev => (prev === TOTAL_SLIDES ? 1 : prev + 1));
        }, 5000);
    };

    const stopAutoSlide = () => {
        if (autoSlideRef.current) {
            clearInterval(autoSlideRef.current);
            autoSlideRef.current = null;
        }
    };

    const pauseAutoSlide = () => {
        stopAutoSlide();

        if (pauseTimeoutRef.current) {
            clearTimeout(pauseTimeoutRef.current);
        }

        pauseTimeoutRef.current = setTimeout(() => {
            startAutoSlide();
        }, 4000);
    };

    const nextSlide = () => {
        pauseAutoSlide();
        setStepT(prev => (prev === TOTAL_SLIDES ? 1 : prev + 1));
    };

    const prevSlide = () => {
        pauseAutoSlide();
        setStepT(prev => (prev === 1 ? TOTAL_SLIDES : prev - 1));
    };

    useEffect(() => {
        scrollToItem(stepT - 1);
    }, [stepT]);

    return (
        <div>
            <div className="Home-CoverSection-Title">
                <div className="Home-CoverSection-Title-Flex">
                    <h2>Why Choose Us</h2>
                    <p>Our website design and development service provides businesses with visually appealing, functional, and performance-optimized websites.</p>
                </div>
            </div>
            <div className="Home-CoverSection">
                {/* Step Selector */}
                <div className="Home-CoverSection-Selector">
                    <div className="Home-CoverSection-Selector-Over" ref={selectorRef}>
                        {[
                        "Results-Driven, Not Just Activity",
                        "Mumbai Market Expertise",
                        "Tailored Digital Strategies",
                        "Creative Meets Performance",
                        "End-to-End Digital Solutions",
                        "Transparent & Collaborative Approach",
                        ].map((text, index) => (
                        <p
                            key={index}
                            ref={(el) => (itemRefs.current[index] = el)}
                            className={stepT === index + 1 ? "Home-active MicroLinksText" : ""}
                            onClick={() => {
                                pauseAutoSlide();
                                setStepT(index + 1);
                                scrollToItem(index);
                            }}
                        >
                            {text}
                        </p>
                        ))}
                    </div>
                </div>
                {/* Cards */}
                <div className="Home-CoverSection-Info">
                    <div className="Home-CoverSection-Info-Arrow">
                        <img onClick={prevSlide} src={Graphic3} alt="" />
                        <img onClick={nextSlide} src={Graphic3} alt="" />
                    </div>
                    <div className="Home-CoverSection-Info-Position">
                        <div className={`Home-CoverSection-Info-Position-Selector Home-CoverSection-Info-Position-Selector-fade ${stepT === 1 ? "Home-CoverSection-Info-Position-Selector-show" : ""}`}></div>
                        <div className={`Home-CoverSection-Info-Position-Selector Home-CoverSection-Info-Position-Selector-fade ${stepT === 2 ? "Home-CoverSection-Info-Position-Selector-show" : ""}`}></div>
                        <div className={`Home-CoverSection-Info-Position-Selector Home-CoverSection-Info-Position-Selector-fade ${stepT === 3 ? "Home-CoverSection-Info-Position-Selector-show" : ""}`}></div>
                        <div className={`Home-CoverSection-Info-Position-Selector Home-CoverSection-Info-Position-Selector-fade ${stepT === 4 ? "Home-CoverSection-Info-Position-Selector-show" : ""}`}></div>
                        <div className={`Home-CoverSection-Info-Position-Selector Home-CoverSection-Info-Position-Selector-fade ${stepT === 5 ? "Home-CoverSection-Info-Position-Selector-show" : ""}`}></div>
                        <div className={`Home-CoverSection-Info-Position-Selector Home-CoverSection-Info-Position-Selector-fade ${stepT === 6 ? "Home-CoverSection-Info-Position-Selector-show" : ""}`}></div>
                    </div>
                    <div className={`Home-CoverSection-Cards HCS1 Home-fade ${stepT === 1 ? "Home-show" : ""}`}>
                        <div className="Home-CoverSection-Cards-Img-Overlay"></div>
                        <img src={Image11} alt="Adstrate Employees working strategy for results" />
                        <div  className="Home-CoverSection-Cards-Info">
                            <h3>Results-Driven, Not Just Activity</h3>
                            <p>
                                We focus on what truly matters—measurable growth. Every strategy we build is aligned with real business goals, ensuring higher engagement, stronger brand visibility, and meaningful ROI.
                            </p>
                        </div>
                    </div>
                    <div className={`Home-CoverSection-Cards HCS2 Home-fade ${stepT === 2 ? "Home-show" : ""}`}>
                        <div className="Home-CoverSection-Cards-Img-Overlay"></div>
                        <img src={Image2} alt="People Planning on White board in Adstrate office" />
                        <div  className="Home-CoverSection-Cards-Info">
                            <h3>Mumbai Market Expertise</h3>
                            <p>
                                As a digital marketing agency based in Mumbai, we understand the local audience, trends, and competitive landscape. This allows us to create hyper-relevant campaigns that connect brands with the right customers at the right time.
                            </p>
                        </div>
                    </div>
                    <div className={`Home-CoverSection-Cards HCS3 Home-fade ${stepT === 3 ? "Home-show" : ""}`}>
                        <div className="Home-CoverSection-Cards-Img-Overlay"></div>
                        <img src={Image3} alt="Playing chess as developing strategy" />
                        <div  className="Home-CoverSection-Cards-Info">
                            <h3>Tailored Digital Strategies</h3>
                            <p>
                                No templates. No guesswork. From social media marketing in Mumbai to Instagram marketing and content creation, our solutions are customized to your brand’s goals, industry, and growth stage.
                            </p>
                        </div>
                    </div>
                    <div className={`Home-CoverSection-Cards HCS4 Home-fade ${stepT === 4 ? "Home-show" : ""}`}>
                        <div className="Home-CoverSection-Cards-Img-Overlay"></div>
                        <img src={Image4} alt="Grphic Designer of Adstrate" />
                        <div  className="Home-CoverSection-Cards-Info">
                            <h3>Creative Meets Performance</h3>
                            <p>
                                We blend data-driven strategy with compelling creativity. Our campaigns are designed not just to look good—but to perform, convert, and scale across digital platforms.
                            </p>
                        </div>
                    </div>
                    <div className={`Home-CoverSection-Cards HCS5 Home-fade ${stepT === 5 ? "Home-show" : ""}`}>
                        <div className="Home-CoverSection-Cards-Img-Overlay"></div>
                        <img src={Image5} alt="our clients interactive with us digitally" />
                        <div  className="Home-CoverSection-Cards-Info">
                            <h3>End-to-End Digital Solutions</h3>
                            <p>
                                From strategy and content to execution and optimization, we manage your entire digital presence seamlessly—so you can focus on running your business while we handle growth.
                            </p>
                        </div>
                    </div>
                    <div className={`Home-CoverSection-Cards HCS6 Home-fade ${stepT === 6 ? "Home-show" : ""}`}>
                        <div className="Home-CoverSection-Cards-Img-Overlay"></div>
                        <img src={Image6} alt="multiple people working collaboratively on a project" />
                        <div  className="Home-CoverSection-Cards-Info">
                            <h3>Transparent & Collaborative Approach</h3>
                            <p>
                                We believe in long-term partnerships built on trust. With clear communication, consistent reporting, and complete transparency, you always know what we’re doing and why.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}